
import { VisualQualityControlDto, CreateVisualQualityControlDto, UpdateVisualQualityControlDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { visualQualityControlService, VisualQualityControlsFilters } from '@services/visualQualityControlService'

const { reducer, actions, thunks } = baseCrudReducer<
  VisualQualityControlDto,
  CreateVisualQualityControlDto,
  UpdateVisualQualityControlDto,
  VisualQualityControlsFilters
>('visualQualityControl', visualQualityControlService)

export default reducer

export const { setFilters: setVisualQualityControlFilters } = actions

export const {
  getAll: getVisualQualityControls,
  create: createVisualQualityControl,
  update: updateVisualQualityControl,
  remove: removeVisualQualityControl,
} = thunks
